import React from 'react'
import { Dialog, DialogContent, DialogActions, Typography, makeStyles } from '@material-ui/core'
import Controls from "../controls/Controls";
import { orange } from '@material-ui/core/colors';

const useStyles = makeStyles(theme => ({
    dialog: {
        padding: theme.spacing(2),
        //position: 'absolute',
        //top: theme.spacing(5)
    },
    dialogTitle: {
        textAlign: 'center',
        textTransform: 'uppercase',
        color: orange[600]
    },
    dialogContent: {
        textAlign: 'center'
    },
    dialogAction: {
        justifyContent: 'center'
    },
    titleIcon: {
        backgroundColor: theme.palette.secondary.light,
        color: theme.palette.secondary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.light,
            cursor: 'default'
        },
        '& .MuiSvgIcon-root': {
            fontSize: '8rem',
        }
    }
}))

export default function WarnDialog(props) {

    const { warnDialog, setWarnDialog } = props;
    const classes = useStyles()

    return (
        <Dialog open={warnDialog.isOpen} classes={{ paper: classes.dialog }}>
            <DialogContent className={classes.dialogContent}>
                <Typography variant="h5" className={classes.dialogTitle}>
                    {warnDialog.title}
                </Typography>
                <Typography variant="subtitle2">
                    {warnDialog.subTitle}
                </Typography>
            </DialogContent>
            <DialogActions className={classes.dialogAction}>
                <Controls.ActionButton
                    text="Continue"
                    style={{ backgroundColor: orange[600] }}
                    onClick={() => setWarnDialog({ ...warnDialog, isOpen: false })} />
            </DialogActions>
        </Dialog>
    )
}